'use strict';

import React from 'react';
import { Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import axios from 'axios';
import Select from 'react-select';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appOperations, appSelectors } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { ordersOperations, ordersSelectors } from '@/state/domains/orders';
import { attemptsOperations, attemptsSelectors } from '@/state/domains/attempts';

import s from './styles.scss';

export default connect(
	(state, props) => ({
		username: usersSelectors.getUsername(state, props),
		date: appSelectors.getPageDate(state, props),
		user: usersSelectors.getLoggedInUser(state, props),
		attempts: attemptsSelectors.getJobAttempts(state, props),
		getUserById: id => usersSelectors.getUserById(state, props)(id)
	}),
	{
		setModalOpen: appOperations.setModalOpen,
		fetchUser: usersOperations.fetchUser,
		fetchAssigned: ordersOperations.fetchAssigned,
		fetchAttempts: attemptsOperations.fetchAttempts,
		postDeleteAttempt: attemptsOperations.postDeleteAttempt
	}
)(
	({ user, attempts, getUserById, setModalOpen }) => {

		if (!attempts) {
			return <div />;
		}

		return (
			<div className={ s.attemptsCont }>
				<div className={ s.attemptsHeader }>Attempts</div>
				<table className={ s.attempts }>
					<thead>
						<tr>
							<th>Date</th>
							<th>Details</th>
							<th>Server</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{ attempts.reduce(
							(as, l) => {

								const { _id, userId, date, type, details } = l;
								console.log('userId', userId);
								const user = getUserById(userId);

								if (type !== 'ATTEMPT') {
									return as;
								}

								return [
									...as,
									<tr key={ _id } >
										<td className={ s.date }>{
											format(new Date(date), 'M/d HH:mm')
										}</td>
										<td>{ !!details && details.join(', ') }</td>
										<td>{  user && user.username }</td>
										<td	className={ s.actions } >
											<div className={ s.edit } onClick={
												() => user._id === userId ? setModalOpen(
													'editAttempt',
													{ attemptId: _id, attempt: l }
												) : null
											} >
												{
													user._id === userId &&
													<FontAwesomeIcon icon='pen-to-square' color='#556'/>
												}
											</div>
											<div className={ s.delete } onClick={
												() => user._id === userId ? setModalOpen(
													'deleteAttempt',
													{ attemptId: _id }
												) : null
											} >
												{
													user._id === userId &&
													<FontAwesomeIcon icon='trash-alt' color='#556'/>
												}
											</div>
										</td>
										
									</tr>
								];
							},
							[]
						)}
					</tbody>
				</table>
			</div>
		);
	}
);
